/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import { dataFetchingClient } from '../../utils/DataFetchingClient';
import { useCallback } from 'react';
import { TABLE_SIZE } from '../table';
import { GET_ALL_USER_PLAYLIST_PROGRESS_QUERY_FIELD_NAME } from '../../../__generated__/chirp/com/hubspot/learning/center/credentials/rpc/PlaylistVisibilityChirpService.dfc.new';
import { useGetPlaylistAssignmentsByIdsQuery, useSearchAggregationQuery, useSearchQuery, useUpdatePlaylistAssignmentMutation, useDeletePlaylistAssignmentMutation, useAssignPlaylistMutation } from '../../../__generated__/chirp/com/hubspot/learning/center/assignments/rpc/PlaylistAssignmentsChirpService.hooks';
import { useSearchUsersOnPortalQuery } from '../../../__generated__/chirp/com/hubspot/learning/center/assignments/rpc/UserChirpService.hooks';
import { SEARCH_QUERY_FIELD_NAME, SEARCH_AGGREGATION_QUERY_FIELD_NAME, GET_PLAYLIST_ASSIGNMENTS_BY_IDS_QUERY_FIELD_NAME } from '../../../__generated__/chirp/com/hubspot/learning/center/assignments/rpc/PlaylistAssignmentsChirpService.dfc.new';
import Raven from 'raven-js';
export const usePlaylistAssignments = ({
  assignmentIds,
  skip
}) => {
  const {
    data,
    loading,
    error
  } = useGetPlaylistAssignmentsByIdsQuery({
    skip,
    variables: {
      assignmentId: assignmentIds
    }
  });
  return {
    playlistAssignments: data === null || data === void 0 ? void 0 : data.playlistAssignments,
    playlistAssignmentsLoading: loading,
    playlistAssignmentsError: error
  };
};
export const usePlaylistAssignmentsPortals = ({
  playlistId,
  offset = 0,
  limit = TABLE_SIZE,
  skip = false,
  query,
  assignedByRequestingUser = false
}) => {
  const {
    data,
    loading,
    error
  } = useSearchAggregationQuery({
    skip,
    variables: {
      playlistId,
      query,
      assignedByRequestingUser,
      pageLength: limit,
      offset: {
        cursor: offset
      }
    }
  });
  return {
    total: data ? data.total : 0,
    playlistAssignmentsPortals: data ? data.results : null,
    playlistAssignmentsPortalsLoading: loading,
    playlistAssignmentsPortalsError: error
  };
};
export const usePlaylistAssignmentsForPortal = ({
  playlistId,
  portalId,
  offset = 0,
  limit = TABLE_SIZE,
  skip = false,
  query,
  assignedByRequestingUser = false
}) => {
  const {
    data,
    loading,
    error
  } = useSearchQuery({
    skip,
    variables: {
      playlistId,
      targetPortalId: portalId,
      query,
      assignedByRequestingUser,
      pageLength: limit,
      offset: {
        cursor: offset
      }
    }
  });
  return {
    total: data ? data.total : 0,
    playlistAssignmentsForPortal: data ? data.results : null,
    playlistAssignmentsForPortalLoading: loading,
    playlistAssignmentsForPortalError: error
  };
};
export const refetchAssignments = () => dataFetchingClient.refetchQueries({
  updateCache(cache) {
    cache.evict({
      fieldName: SEARCH_AGGREGATION_QUERY_FIELD_NAME
    });
    cache.evict({
      fieldName: SEARCH_QUERY_FIELD_NAME
    });
    cache.evict({
      fieldName: GET_ALL_USER_PLAYLIST_PROGRESS_QUERY_FIELD_NAME
    });
    cache.evict({
      fieldName: GET_PLAYLIST_ASSIGNMENTS_BY_IDS_QUERY_FIELD_NAME
    });
  }
});
export const useCreatePlaylistAssignment = ({
  onCompleted
} = {}) => {
  const [mutate, {
    loading: createPlaylistAssignmentLoading,
    error: createPlaylistAssignmentError
  }] = useAssignPlaylistMutation({
    update: async (_cache, {
      errors
    }) => {
      if (errors && errors.length) return;
      await refetchAssignments();
    },
    onCompleted: data => {
      var _data$result$playlist;
      const created = (_data$result$playlist = data.result.playlistAssignments) !== null && _data$result$playlist !== void 0 ? _data$result$playlist : [];
      if (onCompleted) onCompleted(created);
    }
  });
  const createPlaylistAssignment = useCallback(variables => {
    return mutate({
      variables
    }).then(response => {
      if (response && response.data) {
        var _response$data$result;
        const created = (_response$data$result = response.data.result.playlistAssignments) !== null && _response$data$result !== void 0 ? _response$data$result : [];
        return created;
      }
      return null;
    }).catch(err => {
      Raven.captureException(err);
      return null;
    });
  }, [mutate]);
  return {
    createPlaylistAssignment,
    createPlaylistAssignmentLoading,
    createPlaylistAssignmentError
  };
};
export const useUpdatePlaylistAssignments = () => {
  const [mutate, {
    loading: updatePlaylistAssignmentsLoading,
    error: updatePlaylistAssignmentsError
  }] = useUpdatePlaylistAssignmentMutation({
    update: async (_cache, {
      errors
    }) => {
      if (errors && errors.length) return;
      await refetchAssignments();
    }
  });
  const updatePlaylistAssignments = useCallback(variables => {
    return mutate({
      variables: {
        assignmentIds: variables.assignmentIds,
        dueDate: variables.dueDate
      }
    }).catch(error => {
      Raven.captureException(error);
    });
  }, [mutate]);
  return {
    updatePlaylistAssignments,
    updatePlaylistAssignmentsLoading,
    updatePlaylistAssignmentsError
  };
};
export const useDeletePlaylistAssignment = ({
  onCompleted
} = {}) => {
  const [mutate, {
    loading: deletePlaylistAssignmentLoading,
    error: deletePlaylistAssignmentError
  }] = useDeletePlaylistAssignmentMutation();
  const deletePlaylistAssignment = useCallback(variables => {
    return mutate({
      variables: {
        playlistAssignmentId: variables.assignmentId
      }
    }).then(() => {
      if (onCompleted) onCompleted();
    }).catch(error => {
      Raven.captureException(error);
    });
  }, [mutate, onCompleted]);
  return {
    deletePlaylistAssignment,
    deletePlaylistAssignmentLoading,
    deletePlaylistAssignmentError
  };
};
export const useHubSpotterUsersForAccount = ({
  accountId
}) => {
  const {
    data: usersForAccount,
    loading: usersForAccountLoading,
    error: usersForAccountError,
    refetch
  } = useSearchUsersOnPortalQuery({
    variables: {
      targetPortalId: accountId,
      pageLength: 20,
      offset: {
        cursor: 0
      }
    }
  });
  const refetchUsersForAccount = useCallback(async ({
    query,
    offset
  }) => {
    const results = await refetch({
      targetPortalId: accountId,
      query,
      pageLength: 20,
      offset: {
        cursor: offset
      }
    });
    return results.data;
  }, [accountId, refetch]);
  return {
    usersForAccount,
    usersForAccountLoading,
    usersForAccountError,
    refetchUsersForAccount
  };
};